import {isMac} from "@cdx/ds/utils/device-utils";

export function getMetaKeyLabel() {
  return isMac() ? "cmd" : "ctrl";
}

export * from "@cdx/ds/utils/device-utils";
